import { Fragment } from "react"

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

/**
 * Renders text with every occurrence of any active search term wrapped in a
 * highlight span — the ONE match-highlight renderer for the review surfaces
 * (v1 studio tables via `TableSearch`'s re-export, studio-v2's article list).
 * Match indices come from a case-insensitive regex over the ORIGINAL string,
 * never from a lowercased copy — lowercasing can change string length for
 * some Unicode characters (İ → i̇) and shift the slice.
 *
 * `className` picks the surface's own highlight skin: the v1 studio's `hl`
 * (default), or studio-v2's `sv2-artmatch` — NOT bare `sv2-hl`, which is the
 * quote-navigation overlay (position:absolute + multiply blend).
 */
export function Highlight({
  text,
  terms,
  className = "hl",
}: {
  text: string
  terms: string[]
  className?: string
}) {
  const active = [...new Set(terms.map((t) => t.trim()).filter(Boolean))].sort(
    (a, b) => b.length - a.length,
  )
  if (active.length === 0) return <>{text}</>
  const re = new RegExp(`(${active.map(escapeRegExp).join("|")})`, "ig")
  const parts = text.split(re)
  return (
    <>
      {parts.map((p, i) =>
        i % 2 === 1 ? (
          <span key={i} className={className}>
            {p}
          </span>
        ) : (
          <Fragment key={i}>{p}</Fragment>
        ),
      )}
    </>
  )
}
